/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PaginatedDtoOfAttributeIds } from '../../models/paginated-dto-of-attribute-ids';

export interface GetAttributeIds$Params {
}

export function getAttributeIds(http: HttpClient, rootUrl: string, params?: GetAttributeIds$Params, context?: HttpContext): Observable<StrictHttpResponse<PaginatedDtoOfAttributeIds>> {
  const rb = new RequestBuilder(rootUrl, getAttributeIds.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PaginatedDtoOfAttributeIds>;
    })
  );
}

getAttributeIds.PATH = '/api/v1/attributes/ids';
